(function () {
  'use strict';

  /* Mobile menu: full-screen overlay with focus handling */
  var burger = document.getElementById('burger');
  var menu = document.getElementById('menu');
  if (burger && menu) {
    var setMenu = function (open) {
      menu.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      if (open) {
        var first = menu.querySelector('a');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 120);
      }
    };
    burger.addEventListener('click', function () { setMenu(!menu.classList.contains('open')); });
    menu.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('open')) return;
      if (e.key === 'Escape') { setMenu(false); burger.focus(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(menu.querySelectorAll('a')).concat([burger]);
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 760 && menu.classList.contains('open')) setMenu(false); });
  }

  /* Product page: flip image + photo thumbnails */
  var flip = document.getElementById('fl');
  var flipBtn = document.getElementById('fb');
  var mainImg = document.getElementById('pi');
  var thumbs = [].slice.call(document.querySelectorAll('.thumb'));
  if (flip && flipBtn) {
    flipBtn.addEventListener('click', function () {
      var on = flip.classList.toggle('flipped');
      flipBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      flipBtn.setAttribute('aria-label', on ? 'Show the front of the star' : 'Show the back of the star');
    });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.s;
      mainImg.alt = t.dataset.a;
      mainImg.className = t.dataset.p === '1' ? 'photo' : '';
      if (flip) flip.classList.remove('flipped');
      if (flipBtn) {
        flipBtn.setAttribute('aria-pressed', 'false');
        flipBtn.hidden = t.dataset.p === '1';
      }
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    });
  });

  /* Gallery page: photo viewer */
  var lb = document.getElementById('lb');
  if (lb) {
    var tiles = [].slice.call(document.querySelectorAll('.tile'));
    var li = document.getElementById('li');
    var lc = document.getElementById('lc');
    var cur = 0;
    var opener = null;
    var show = function (i) {
      cur = (i + tiles.length) % tiles.length;
      var im = tiles[cur].querySelector('img');
      li.src = im.src;
      li.alt = im.alt;
      lc.textContent = (cur + 1) + ' / ' + tiles.length;
    };
    var openLb = function (i) {
      opener = document.activeElement;
      show(i);
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.getElementById('lx').focus();
    };
    var closeLb = function () {
      lb.classList.remove('open');
      document.body.style.overflow = '';
      if (opener) opener.focus();
    };
    tiles.forEach(function (t, i) { t.addEventListener('click', function () { openLb(i); }); });
    document.getElementById('lx').addEventListener('click', closeLb);
    document.getElementById('lp').addEventListener('click', function () { show(cur - 1); });
    document.getElementById('ln').addEventListener('click', function () { show(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  }

  /* Reviews page: filter by product */
  var flt = document.getElementById('flt');
  if (flt) {
    flt.addEventListener('change', function () {
      [].slice.call(document.querySelectorAll('.rev')).forEach(function (r) {
        r.hidden = !!flt.value && r.getAttribute('data-product') !== flt.value;
      });
    });
  }

  /* Parallax images */
  var pxs = [].slice.call(document.querySelectorAll('[data-parallax]'));
  if (pxs.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight;
      pxs.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        el.style.setProperty('--py', (p * -el.offsetHeight * 0.1).toFixed(1) + 'px');
      });
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* Product cards: flip to the second image */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.cflip') : null;
    if (!b) return;
    var cf = b.closest('.card').querySelector('.cf');
    var on = cf.classList.toggle('flipped');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Show the front' : 'Show the back');
  });

  /* Add to cart without leaving the page */
  var toast = document.getElementById('toast');
  var toastTimer;
  var showToast = function (html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (n) { n.textContent = cart.item_count; });
        showToast('<span>Added to your cart</span><a href="' + root + 'cart">View cart</a>');
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* Product page: quantity, variant price, sticky buy bar */
  var qin = document.getElementById('qty');
  [].slice.call(document.querySelectorAll('.qb')).forEach(function (b) {
    b.addEventListener('click', function () {
      var v = parseInt(qin.value, 10) || 1;
      qin.value = Math.max(1, Math.min(99, v + parseInt(b.dataset.qty, 10)));
    });
  });
  var variant = document.getElementById('variant');
  if (variant) {
    variant.addEventListener('change', function () {
      var p = variant.options[variant.selectedIndex].getAttribute('data-price');
      var pe = document.querySelector('.pdp-info .price span');
      var bp = document.getElementById('buybar-price');
      if (p && pe) pe.textContent = p;
      if (p && bp) bp.textContent = p;
    });
  }
  var buybar = document.getElementById('buybar');
  var buybtn = document.getElementById('buybtn');
  if (buybar && buybtn) {
    document.getElementById('buybar-btn').addEventListener('click', function () {
      document.getElementById('product-form').requestSubmit(buybtn);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { buybar.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
        document.documentElement.classList.toggle('has-buybar', !buybar.hidden); }, { threshold: 0 }).observe(buybtn);
    }
  }
})();
